// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"8bbac0ca","902":"5fb45096"}[chunkId] + ".chunk.js";
};